import React from "react";
import { Link } from "react-router-dom";

// Primary — Navy Ink block, ivory text, sharp edges
export const PrimaryButton = ({ to, children, onClick, type, className = "", ...rest }) => {
  const cls =
    "inline-flex items-center justify-center gap-3 bg-ink text-ivory px-8 py-4 text-[0.78rem] tracking-[0.16em] uppercase font-semibold transition-all duration-500 hover:bg-[#16294c] disabled:opacity-50 " +
    className;
  if (to) {
    return (
      <Link to={to} className={cls} {...rest}>
        {children}
      </Link>
    );
  }
  return (
    <button type={type || "button"} onClick={onClick} className={cls} {...rest}>
      {children}
    </button>
  );
};

// Secondary — ghost, 1px ink border, fills on hover
export const GhostButton = ({ to, children, onClick, className = "", ...rest }) => {
  const cls =
    "inline-flex items-center justify-center gap-3 border border-ink text-ink px-8 py-4 text-[0.78rem] tracking-[0.16em] uppercase font-semibold transition-all duration-500 hover:bg-ink hover:text-ivory " +
    className;
  if (to) {
    return (
      <Link to={to} className={cls} {...rest}>
        {children}
      </Link>
    );
  }
  return (
    <button onClick={onClick} className={cls} {...rest}>
      {children}
    </button>
  );
};

// Tertiary — text link with brass underline reveal
export const TextLink = ({ to, children, className = "", ...rest }) => (
  <Link
    to={to}
    className={"link-underline eyebrow text-ink inline-flex items-center gap-2 " + className}
    {...rest}
  >
    {children}
  </Link>
);
